<template>
    <modal-wrapper modalClass="modal--form" :modalName="name" @before-open="beforeOpen">
        <div class="modal__header">
            <h1 v-if="invoice.id">{{$t('modals.edit_invoice.title')}}</h1>
            <h1 v-else>{{$t('modals.create_invoice.title')}}</h1>
        </div>

        <invoice-form
            :invoice = "invoice"
            :wrapperClass="['modal__content']"
            @saved="onInvoiceSaved">

            <div class="modal__footer" slot="buttons" slot-scope="{ isSaveDisabled }">
                <div class="actions">
                    <button class="actions__action--save pull-right" type="submit" :class="{disabled: isSaveDisabled}" :disabled="isSaveDisabled">{{$t('common.save')}}</button>
                    <button class="actions__action--cancel" type="button" @click="$modal.hide(name)">{{$t('modals.common.cancel')}}</button>
                </div>
            </div>
        </invoice-form>
    </modal-wrapper>
</template>
<script>
    import Vue from 'vue';
    import { Component } from 'vue-property-decorator';
    import ModalWrapper from '@/components/general/ModalWrapper';

    import InvoiceForm from '@/components/forms/dashboard/InvoiceForm';

    @Component({
        components: {
            InvoiceForm,
        }
    })
    export default class InvoiceModal extends Vue {
        name = 'invoice-modal';

        invoice = {};

        beforeOpen(event) {
            if (event.params && event.params.invoice) {
                this.invoice = event.params.invoice;
            }
        }

        onInvoiceSaved(invoice) {
            this.$modal.hide(this.name);
            this.$router.push({ name: 'edit-invoice', params: { trajectoryId: this.$store.state.trajectory.trajectory.id, invoiceId: invoice.id }});
        }
    }
</script>



// WEBPACK FOOTER //
// src/components/modals/dashboard/InvoiceModal.vue